import debounce from 'lodash.debounce';
import { BREAKPOINT_LG } from 'utils/breakpoint';
import { closeAllMenuMobileNav } from './MobileNav';

interface NavbarTogglerProps {
    el: HTMLDivElement;
    props: {
        target: string;
    };
}

const DEBOUNCE_VALUE = 100;

const NavbarToggler = ({ el, props }: NavbarTogglerProps): void => {
    const { target } = props;

    const targetEl = document.querySelector(target) as HTMLDivElement | null;
    if (!targetEl) {
        return;
    }

    const closeMobileNav = (): void => {
        targetEl.classList.remove('is-open');
        el.classList.remove('disabled');
        el.setAttribute('aria-expanded', 'false');
        closeAllMenuMobileNav({ el: targetEl });
        document.body.classList.remove('modal-opened');
    };

    const openMobileNav = (): void => {
        targetEl.classList.add('is-open');
        el.classList.remove('disabled');
        el.setAttribute('aria-expanded', 'true');
        document.body.classList.add('modal-opened');
    };

    // set default as close if no is-open class
    if (!targetEl.classList.contains('is-open')) {
        el.setAttribute('aria-expanded', 'false');
    }

    el.addEventListener('click', () => {
        if (el.classList.contains('disabled')) {
            return;
        }

        if (targetEl.classList.contains('is-open')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });

    const windowResizeCheck = (): void => {
        // if menu is opened while transition from mobile to desktop, close the mobile nav
        if (window.innerWidth > BREAKPOINT_LG && targetEl.classList.contains('is-open')) {
            closeMobileNav();
        }
    };

    windowResizeCheck();
    window.addEventListener('resize', debounce(windowResizeCheck, DEBOUNCE_VALUE));
};

export default NavbarToggler;
